import React from 'react';
import './TechNeedSection.css';
import VideoPlayer from './VideoPlayer';

const CheckIcon = () => (
  <svg 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    className="check-icon"
    width="1em"
    height="1em"
  >
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
  </svg>
);

const TechNeedSection: React.FC = () => {
  const bulletPoints = [
    'Future-ready skills for emerging industries',
    'Creative problem-solving and innovation mindset',
    'Global competitiveness and collaboration',
    'Empowerment to create, not just consume',
    'Tools to address real-world challenges'
  ];

  return (
    <section className="tech-need-section">
      <div className="gradient-bg"></div>
      <div className="container">
        <div className="tech-need-content">
          <div className="video-column">
            <div className="video-wrapper">
              <VideoPlayer />
            </div>
          </div>
          
          <div className="text-column">
            <div className="content-wrapper">
              <h2 className="section-title">Tech is the Need of the Hour</h2>
              <h3 className="section-subtitle">Preparing our youth for a future powered by innovation.</h3>
              
              <p className="main-text">
                In today's fast-changing world, technology shapes every aspect of life — from how we communicate 
                to how we solve problems. Learning Robotics, IoT, Drone Tech, and more is essential to develop 
                the skills that will define tomorrow's leaders and innovators.
              </p>
              
              <ul className="benefits-list">
                {bulletPoints.map((point, index) => (
                  <li key={index}>
                    <CheckIcon />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              
              <p className="closing-text">
                At IIITD-IC Summer Camp 2026, we ignite passion and provide hands-on experiences to nurture confident
                tech innovators.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechNeedSection;
